import type { Tag } from '../../../../authz/gen/ai/h2o/workspace/v1/tag_pb';
import type { PageFiltersElement } from '../../../../components/PageFilters/types';
import { DateCreatedFilter, dateCreatedFilterKey } from './DateCreatedFilter';
import { OwnerFilter, ownerFilterKey } from './OwnerFilter';
import { TagsFilter, tagsFilterKey } from './TagsFilter';

type DateCreatedValue = {
  dateStart?: string;
  dateEnd?: string;
};

const workspaceOwnerFilter: PageFiltersElement<string> = {
  key: ownerFilterKey,
  filterName: 'Owner',
  render: (value, onChange, label, key, disabled) => (
    <OwnerFilter value={value} onChange={onChange} disabled={disabled} inputLabel={label} key={key} />
  ),
};

const workspaceDateCreatedFilter: PageFiltersElement<DateCreatedValue> = {
  key: dateCreatedFilterKey,
  filterName: 'Date Created',
  render: (value, onChange, label, key, disabled) => (
    <DateCreatedFilter value={value} onChange={onChange} disabled={disabled} inputLabel={label} key={key} />
  ),
};

export const createWorkspaceTagsFilter = (availableTags?: Tag[]): PageFiltersElement<string[]> => ({
  key: tagsFilterKey,
  filterName: 'Tags',
  render: (value, onChange, label, key, disabled) => (
    <TagsFilter
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputLabel={label}
      key={key}
      availableTags={availableTags}
    />
  ),
});

export const createWorkspaceFiltersConfig = (availableTags?: Tag[]) => [
  workspaceOwnerFilter,
  workspaceDateCreatedFilter,
  createWorkspaceTagsFilter(availableTags),
];
